module.exports = __webpack_public_path__ + "media/images/icons/calendarIcon-6777232495daf4f27d782dc3a3e8bbbe.svg";